import { render, staticRenderFns } from "./EditTagsModal.vue?vue&type=template&id=19c2d992&scoped=true&"
import script from "./EditTagsModal.vue?vue&type=script&lang=js&"
export * from "./EditTagsModal.vue?vue&type=script&lang=js&"
import style0 from "./EditTagsModal.vue?vue&type=style&index=0&id=19c2d992&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c2d992",
  null
  
)

export default component.exports